import { useSync } from '@/hooks/useSync';
import { selectSyncing } from '@/redux/config/configSlice';
import { useAppSelector } from '@/redux/hooks';
import { DisconnectOutlined, LoadingOutlined, SyncOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const SyncButton = () => {
  const { t } = useTranslation();
  const syncing = useAppSelector(selectSyncing);
  const { startSync } = useSync();
  const [online, setOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setOnline(true);
    const handleOffline = () => setOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (!online) {
    return (
      <Tooltip title={t('common:no_internet_connection')}>
        <Button
          type="default"
          block
          disabled
          icon={<DisconnectOutlined />}
          className="flex items-center justify-center h-10 bg-gray-100 dark:bg-gray-800 text-gray-400"
        >
          <span>{t('common:offline')}</span>
        </Button>
      </Tooltip>
    );
  }

  return (
    <Button
      type="default"
      block
      onClick={startSync}
      loading={syncing}
      icon={syncing ? <LoadingOutlined /> : <SyncOutlined />}
      className="flex items-center justify-center h-10 bg-gray-50 dark:bg-gray-800 hover:bg-primary hover:text-white transition-colors duration-300"
    >
      <span>{t('common:sync_data')}</span>
    </Button>
  );
};

export default SyncButton;
